module.exports = __webpack_public_path__ + "static/media/expired.e0b1ba98.png";